import React from "react";


import ImageLoadingHook from "../../../shared/hooks/ImageLoadingHook";


import scrollTo from "../../../shared/util/scrollTo";



import introPic from '../../../shared/images/intro/003.jpg'
import introPicLQ from '../../../shared/images/intro/003_lq.jpg'




import logoCS from '../../../shared/images/logo/cropped-Combat-Sports-Luebeck_Logo2018.png'

import './Intro.css'


const Intro = function (props) {



    const [src, { blur }] = ImageLoadingHook(introPicLQ, introPic);




    const handleScrollIntroButton = function (e) {
        e.preventDefault();
        scrollTo({ ref: props.reference, duration: 1000 })
    }





    const cardVariants = {
        offscreen: {
            y: 300
        },
        onscreen: {
            y: 50,
            rotate: 0,
            transition: {
                type: "spring",
                bounce: 0.4,
                duration: 0.8
            }
        }
    };



    return (
        <React.Fragment>
            <div className='intro-div' >


                <div className="intro-clip-div-bot-one" />
                {/* <div className="intro-clip-div-bot-two" /> */}
                <img src={src}
                    style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: -20,
                        bottom: 0,
                        width: "100%",
                        height: "100%",
                        padding: 0,
                        margin: 0,
                        objectFit: "cover",
                        filter: blur ? "blur(10px)" : "blur(0px)",
                        transition: blur ? "none" : "filter 0.3s ease-out",
                        clipPath: "polygon(0 0, 100% 0, 100% 95%, 0% 100%)",
                        // clipPath: "polygon(0 99%, 100% 99%, 100% 0, 0 0)",
                    }}
                    className="intro-background"
                    alt="test" />

                <img src={logoCS} className="intro-logo" alt="combat sports"></img>



                <button href="#" className="scroll-down" onClick={handleScrollIntroButton} address="true"> </button>

            </div>







            {/* <div ref={props.reference} className='intro'>
                <div className='intro-left'>
                    <div className="intro-left-wrapper">
                        <h2 className="intro-intro">Willkommen bei</h2>
                        <h1 className="intro-name">Combat Sports Lübeck</h1>
                        <div className="intro-title">
                            <div className="intro-title-wrapper">
                                <div className="intro-title-item">Muay Thai</div>
                                <div className="intro-title-item">Mixed Martial Arts</div>
                                <div className="intro-title-item">Kettlebells</div>
                                <div className="intro-title-item">Powerlifting</div>
                                <div className="intro-title-item">Bodybuilding</div>
                            </div>
                        </div>
                        <p className="intro-description">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </p>


                    </div>


                </div>

            </div> */}












        </React.Fragment >


    );
}


export default Intro;